import { useEffect, useState, type ReactNode } from "react";

import { useStatesListQuery } from "~/services";
import { OTHER_STATES_OPTIONS } from "~/shared.types";
import { Dropdown, Option } from "~/ui";

interface StateDropdownProps {
  value?: number | null;
  onChange: (value: number | null) => void;
  isEligible?: boolean;
  disabled?: boolean;
  showOtherOption?: boolean;
  showVermontOption?: boolean;
  error?: string;
  description?: ReactNode;
  onClose?: () => void;
}

export const StateDropdown = ({
  value,
  onChange,
  isEligible,
  disabled = false,
  showOtherOption = false,
  showVermontOption = false,
  error,
  description,
  onClose,
}: StateDropdownProps) => {
  const [options, setOptions] = useState<Option<number>[]>([]);

  const { data: states } = useStatesListQuery({ isEligible });

  useEffect(() => {
    if (states) {
      const options: Option<number>[] = states
        ?.filter((state) => !!state?.id)
        .map((state) => ({
          value: state.id,
          label: state.name,
        }));

      if (showVermontOption) {
        options.push(OTHER_STATES_OPTIONS.VERMONT);
      }

      if (showOtherOption) {
        options.push(OTHER_STATES_OPTIONS.OTHER);
      }

      setOptions(options);
    }
  }, [states, showOtherOption, showVermontOption]);

  return (
    <Dropdown
      options={options}
      value={value ?? undefined}
      placeholder="Please select"
      label="State"
      disabled={disabled}
      onChange={onChange}
      error={error}
      description={description}
      onClose={onClose}
    />
  );
};
